import { apiClient } from "services/api-client";

/**
 * Dashboard API Service
 * Provides executive-level metrics and portfolio risk analytics
 */

// ========== EXECUTIVE DASHBOARD METRICS ==========

/**
 * Get compliance metrics (Supply Chain Compliance Index)
 */
export const getComplianceMetrics = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/metrics?companyKey=${tenant}`);
};

/**
 * Get portfolio risk heatmap data
 * Groups vendors by tier and trust score classification
 */
export const getRiskHeatmap = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/heatmap?companyKey=${tenant}`);
};

/**
 * Get domain vulnerability radar chart data
 * Shows compliance rates by SCF control domain
 */
export const getDomainVulnerability = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/domain-vulnerability?companyKey=${tenant}`);
};

/**
 * Get Liability Watch list
 * High-risk vendors requiring immediate attention
 */
export const getLiabilityWatch = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/liability-watch?companyKey=${tenant}`);
};

/**
 * Get Vendor Monitoring list
 * Consolidated portfolio view — every active vendor, not just dataSensitivity >= 4 vendors
 */
export const getVendorMonitoring = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/vendor-monitoring?companyKey=${tenant}`);
};

/**
 * Get Assessment Pipeline
 * Counts of in-flight assessments grouped by stage
 */
export const getAssessmentPipeline = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/assessment-pipeline?companyKey=${tenant}`);
};

// ========== ADDITIONAL DASHBOARD DATA ==========

/**
 * Get trend data for trust scores over time
 */
export const getTrustScoreTrends = async (tenant, period = '30d') => {
  return await apiClient.get(`/vendor/dashboard/trends?companyKey=${tenant}&period=${period}`);
};

/**
 * Get DPA compliance summary
 */
export const getDPACompliance = async (tenant) => {
  return await apiClient.get(`/vendor/dashboard/dpa-compliance?companyKey=${tenant}`);
};
